//@ts-check

export const constrain = (
  /** @type {number} */ value,
  /** @type {number | null} */ min,
  /** @type {number | null} */ max
) => {
  if (min !== null) {
    value = Math.max(value, min);
  }
  if (max !== null) {
    value = Math.min(value, max);
  }
  return value;
};

/**
 * @param  {...number|null} values
 * @returns {number | null} The maximum value or null if no valid values are provided.
 */
export const max = (...values) => {
  return values.reduce((tmpMaxValue, currentValue) => {
    if (currentValue === null || typeof currentValue === "undefined") {
      return tmpMaxValue;
    }
    if (tmpMaxValue === null || typeof tmpMaxValue === "undefined") {
      return currentValue;
    }
    return Math.max(tmpMaxValue, currentValue);
  }, null);
};

/**
 * @param  {...number|null} values
 * @returns {number | null} The minimum value or null if no valid values are provided.
 */
export const min = (...values) => {
  return values.reduce((tmpMinValue, currentValue) => {
    if (currentValue === null || typeof currentValue === "undefined") {
      return tmpMinValue;
    }
    if (tmpMinValue === null || typeof tmpMinValue === "undefined") {
      return currentValue;
    }
    return Math.min(tmpMinValue, currentValue);
  }, null);
};
